<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="primary">
          <span style="color: #fff" class="text-h5">Duplicar Aula</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
              <form @submit.prevent="handleSubmit(enableSubmit)" :disabled="false">
                <v-row>
                  <v-col class="pt-4 pb-0" cols="12">
                    <e-label class="font-weight-medium">Tipo de Aula</e-label>
                    <p class="font-weight-regular">
                      {{ aulaDuplicada.tipo_de_aula }}
                    </p>
                  </v-col>
                  <v-col class="pt-0 pb-0" cols="12">
                    <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                      <e-label>Selecione uma data</e-label>

                      <e-date-picker-calendario-letivo
                        ref="datePickerCalendarioLetivo"
                        v-model="dataAulaDuplicada"
                        :gestao-de-aula="gestaoDeAulas.gestao"
                        :inicio-periodo-etapa="etapa?.periodo_inicial"
                        :fim-periodo-etapa="etapa?.periodo_final"
                        :error-messages="errors"
                        label="Escolha uma data"
                        @date-changed="onDateChanged"
                        @horarios-changed="onHorariosChanged"
                      />
                    </ValidationProvider>
                  </v-col>

                  <v-col
                    class="pt-0 pb-0"
                    v-if="aulaDuplicada.tipo_de_aula !== 'Aula Remota'"
                    cols="12"
                  >
                    <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                      <e-label>Selecione um horário</e-label>
                      <v-select
                        :items="horariosDisponiveis"
                        :error-messages="errors"
                        label="Selecione uma opção"
                        :item-text="(item) => item.descricao"
                        v-model="horarioSelecionado"
                        @change="() => pesquisaAulas()"
                        return-object
                        dense
                        solo
                        autocomplete="off"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-alert
                      v-show="messageAlert"
                      class="clickable"
                      border="left"
                      elevation="3"
                      type="warning"
                      >{{ messageAlert }}</v-alert
                    >
                    <e-label class="font-weight-medium mb-5">Conteúdo</e-label>
                    <div class="font-weight-regular" v-html="aulaDuplicada.conteudo"></div>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium">Metodologia</e-label>
                    <p class="font-weight-regular">
                      {{ aulaDuplicada.metodologia }}
                    </p>
                  </v-col>
                </v-row>

                <v-divider class="my-6"></v-divider>
                <e-progresso-preenchimento
                  :expectedItems="itemsEsperadosFiltrados"
                  :filledItems="itemsPreenchidos"
                  @total-filled-changed="
                    (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                  "
                />

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    style="color: #fff"
                    class="red darken-1"
                    @click="$emit('dialogChange', false), limparCampos()"
                  >
                    Fechar
                  </v-btn>
                  <v-btn
                    :disabled="desabilitarSalvamento || !totalmentePreenchido"
                    style="color: #fff"
                    class="green darken-1"
                    type="submit"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="duplicarAula"
    >
    </e-modal-confirm>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
    gestaoDeAulas: {
      type: Object,
      require: true,
    },
    horarios: {
      type: Array,
      require: true,
    },
    disciplinas: {
      type: Array,
    },
    etapa: {
      type: Object,
    },
  },
  data() {
    return {
      messageAlert: null,
      desabilitarSalvamento: false,
      aulaDuplicada: {},
      confirmDialog: false,
      dataAulaDuplicada: null,
      horariosDisponiveis: [],
      objectModal: {
        title: "Duplicar aula",
        message: "Tem certeza que deseja duplicar esta aula?",
      },
      horarioSelecionado: null,
      itemsEsperados: [
        { label: "Data", value: "dataAulaDuplicada" },
        { label: "Horário", value: "horarioSelecionado" },
      ],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
    };
  },
  computed: {
    aulaRemota() {
      return this.aulaDuplicada?.tipo_de_aula === "Aula Remota";
    },
    itemsEsperadosFiltrados() {
      if (this.aulaRemota) {
        return this.itemsEsperados.filter((item) => item.value !== "horarioSelecionado");
      }
      return this.itemsEsperados;
    },
  },
  created() {
    // Cria um watcher para cada item esperado (value).
    this.itemsEsperadosFiltrados.forEach((item) => {
      this.$watch(item.value, (val) => {
        this.$toggleItemPreenchidoBarraProgresso(item.value, val, this.itemsPreenchidos);
      });
    });
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.aulaDuplicada = val;
      },
    },
  },
  methods: {
    async pesquisaAulas() {
      const data_aula = this.data.split("/").reverse().join("-");
      /* eslint-disable */
      const { id } = this.aulaDuplicada;
      const horario_id = this.horarioSelecionado.id;
      if (!data_aula || !this.horarioSelecionado) return;

      let response = await this.$services.aulasComplementaresService.pesquisarAulasEmConflitos(
        data_aula,
        horario_id,
        this.$route.params.gestaoDeAulaId,
        id
      );

      if (this.gestaoDeAulas?.gestao?.is_polivalencia === 1) {
        response = await this.$services.aulasService.pesquisarAulasEmConflitosPoli(
          data_aula,
          horario_id,
          this.aulaDuplicada.turma_id,
          this.aulaDuplicada.id
        );
      }

      if (response.data?.length === 0) {
        this.desabilitarSalvamento = false;
        this.messageAlert = "";
      } else {
        this.desabilitarSalvamento = true;
        this.messageAlert = "Já existe uma aula cadastrada nesta mesma data e horário selecionado";
      }
    },
    onDateChanged() {
      this.horarioSelecionado = null;
    },

    onHorariosChanged(horarios) {
      this.horariosDisponiveis = horarios;

      if (this.horarioSelecionado) {
        const horarioExists = horarios.some((h) => h.id === this.horarioSelecionado.id);
        if (!horarioExists) {
          this.horarioSelecionado = null;
        }
      }
    },

    enableSubmit() {
      if (!this.dataAulaDuplicada || !this.horarioSelecionado?.id) {
        this.$toast.danger("Preencha todos os campos obrigatórios: data e horário.");
        return;
      }
      this.confirmDialog = !this.confirmDialog;
    },
    async duplicarAula() {
      this.$loaderService.open("Duplicando a Aula");
      try {
        // Converter data de DD/MM/YYYY para YYYY-MM-DD
        const partesData = this.dataAulaDuplicada.split("/");
        const dataFormatada = `${partesData[2]}-${partesData[1]}-${partesData[0]}`;

        this.aulaDuplicada.data = dataFormatada;
        this.aulaDuplicada.horario_inicial = this.horarioSelecionado
          ? this.horarioSelecionado.inicio
          : null;
        this.aulaDuplicada.horario_final = this.horarioSelecionado
          ? this.horarioSelecionado.final
          : null;
        this.aulaDuplicada.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
        this.aulaDuplicada.gestao_de_aula = parseInt(this.$route.params.gestaoDeAulaId, 10);
        this.aulaDuplicada.disciplina_id = this.gestaoDeAulas.disciplina_id;
        this.aulaDuplicada.turma_id = this.gestaoDeAulas.turma_id;
        this.aulaDuplicada.instrutor_id = this.gestaoDeAulas.instrutor_id;
        await this.$services.aulasService.criar(this.aulaDuplicada);
        this.confirmDialog = !this.confirmDialog;
        this.$emit("dialogChange", false);
        this.$toast.success("Aula duplicada com sucesso!");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.limparCampos();
        this.$loaderService.close();
      }
    },
    limparCampos() {
      this.dataAulaDuplicada = null;
      this.horarioSelecionado = null;
      this.horariosDisponiveis = [];
      this.totalmentePreenchido = false;

      if (this.$refs.datePickerCalendarioLetivo) {
        this.$refs.datePickerCalendarioLetivo.limpar();
      }

      this.$nextTick(() => {
        this.$refs.observer.reset();
      });
    },
  },
};
</script>
